import styled from 'styled-components';
export const StatusMessage = styled.span ``;
